import { useMemo } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchCustomFields } from 'api/customFields';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { customFieldQueryKeys } from 'queries/custom-field-query-keys';

const useContactTableCustomFields = () => {
    const { accountId } = useCurrentAccount();
    const { data: customFields } = useSuspenseQuery({
        queryKey: customFieldQueryKeys.customFieldsWithFilters(accountId, {
            group: 'contact',
            limit: 999,
        }),
        queryFn: () => fetchCustomFields(accountId, { group: 'contact', limit: 999 }),
        staleTime: Infinity,
        refetchOnWindowFocus: false,
    });
    return useMemo(() => customFields.data ?? [], [customFields.data]);
};

export { useContactTableCustomFields };
